import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  templateUrl: './control-error.component.html',
  styleUrls: [ './control-error.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
 })
 export class ControlErrorComponent {
  private errs: string[] = [];
  private hide = false;

  constructor(private cdr: ChangeDetectorRef) { }

  @Input() set errors(errors: string[]) {
    if (errors.length < 1) {
      this.hide = true;
    } else {
      this.errs = errors;
      this.hide = false;
    }

    this.cdr.detectChanges();
  }

  get shouldHide(): boolean {
    return this.hide;
  }

  get errorMessages(): string[] {
    return this.errs;
  }
 }
